import { useEffect, useState } from "react";
import AboutTab from "./aboutTab";
import WorkingHoursTab from "./workingHoursTab";
import { FiEdit2 } from "react-icons/fi";
import EditProfileModal from "./editProfileModal";
import { profileApi } from "@/api/profileApi";
import { IProfile } from "@/interfaces/Iprofile";
import { IworkingHours } from "@/interfaces/Ibusiness";

export default function myprofile() {
  const [activeTab, setActiveTab] = useState("about");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [profileData, setProfileData] = useState<IProfile | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      const response = await profileApi.getProfile();
      console.log("response from getProfile", response);
      setProfileData(response.data);
    };
    fetchProfile();
  }, []);

  const handleWorkingHoursSave = async (
    workingHours: IworkingHours,
    timezone?: string
  ) => {
    if (!profileData) return;

    try {
      setIsLoading(true);
      const updatedProfile = {
        ...profileData,
        working_hours: workingHours,
        ...(timezone && { timezone }),
      };

      console.log("Profile update - timezone received:", timezone);
      console.log(
        "Profile update - updatedProfile.timezone:",
        updatedProfile.timezone
      );

      const response = await profileApi.updateProfile(updatedProfile);

      if (response.data) {
        const updatedData = {
          ...profileData,
          ...response.data,
          working_hours: workingHours,
        };
        setProfileData(updatedData);
      }
    } catch (error) {
      console.error("Error updating working hours:", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const handleProfileUpdate = (updatedProfile: IProfile) => {
    setProfileData(updatedProfile);
  };

  return (
    <div className="flex-1 overflow-auto">
      <div className="mx-auto py-8 px-8">
        {/* Profile Header */}
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-[#78C7D1] rounded-full flex items-center justify-center text-white text-xl">
              {profileData?.first_name?.charAt(0)}
              {profileData?.last_name?.charAt(0)}
            </div>
            <div>
              <h2 className="text-lg font-medium">
                {profileData?.first_name} {profileData?.last_name}
              </h2>
              <p className="text-sm text-gray-500">
                {profileData?.timezone} · {profileData?.timezone}
              </p>
            </div>
          </div>
          <button
            onClick={() => setIsEditModalOpen(true)}
            className="p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100"
          >
            <FiEdit2 size={20} />
          </button>
        </div>

        {/* Tabs */}
        <div className="flex space-x-6 border-b border-gray-200">
          <button
            className={`pb-4 ${
              activeTab === "about"
                ? "text-gray-900 border-b-2 border-[#78C7D1]"
                : "text-gray-500"
            }`}
            onClick={() => setActiveTab("about")}
          >
            About
          </button>
          <button
            className={`pb-4 ${
              activeTab === "working_hours"
                ? "text-gray-900 border-b-2 border-[#78C7D1]"
                : "text-gray-500"
            }`}
            onClick={() => setActiveTab("working_hours")}
          >
            Working hours
          </button>
        </div>

        {/* Tab Content */}
        <div className="py-6">
          {activeTab === "about" && profileData && (
            <AboutTab profileData={profileData} />
          )}
          {activeTab === "working_hours" && profileData && (
            <WorkingHoursTab
              profileData={profileData}
              isLoading={isLoading}
              handleSave={handleWorkingHoursSave}
            />
          )}
        </div>

        {/* Edit Profile Modal */}
        <EditProfileModal
          isOpen={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          profileData={profileData}
          onProfileUpdate={handleProfileUpdate}
        />
      </div>
    </div>
  );
}
